export const formatInput = (inputObj) => {
  const copyObj = { ...inputObj };
  const formattedInput = Object.entries(copyObj).filter((input) => {
    if (input[1] === "" || input[1].length < 1) return null;
    return input;
  });
  return formattedInput;
};
